import instance from "./instance";
export const findAll = () => {
    return instance.get(`/answers`)
        .then(response => ({ response }))
        .catch(error => ({ error }));
};
